<template>
  <div>
    <!-- <div class="add-title">
      <span>试题管理 /</span>
      {{$route.query.upId?($route.query.upPid!="0"?"编辑小题":"编辑常规试题"):($route.query.id?"添加小题":"添加常规试题") }}
    </div>-->
    <el-card style="margin-bottom:20px;font-size:14px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item
          :to="($route.query.chapterId||$route.query.examId)?{ path: '/examView',query:{
         chapterId: $route.query.chapterId,
         examId: $route.query.chapterId
        } }:{ path: '/question' }"
        >试题管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.query.upId?($route.query.upPid!="0"?"编辑小题":"编辑常规试题"):($route.query.id?"添加小题":"添加常规试题") }}</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>
    <div id="addQuestion">
      <div style="display:flex;flex-direction: row;">
        <div style="width:70%;background: #fff;">
          <el-form
            ref="addForm"
            :model="addForm"
            :label-width="formLabelWidth"
            :rules="addFormRules"
          >
            <el-row :span="24">
              <el-col v-if="bigTittle" :span="24">
                <el-form-item label="大题题干">
                  <div class="big-tittle" v-html="bigTittle"></div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :span="24">
              <!-- <el-col v-if="(!this.$route.query.id&&this.$route.query.upPid=='0')" :span="12"> -->
              <el-col
                v-if="!$route.query.chapterId&&!$route.query.examId&&($route.query.upPid==0||!$route.query.upPid)&&!$route.query.id"
                :span="12"
              >
                <el-form-item label="具体课程" prop="courseId">
                  <el-cascader
                    clearable
                    :show-all-levels="false"
                    v-model="addForm.courseId"
                    :props="subjectTreeProps"
                    placeholder="请输入具体课程"
                    :options="subjectTreeList"
                    @change="subjectChange"
                  ></el-cascader>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="试题题型" prop="questionTypeId">
                  <el-select
                    clearable
                    :disabled="$route.query.upId?true:false"
                    v-model="addForm.questionTypeId"
                    @change="typeChange"
                    placeholder="请输入试题题型"
                  >
                    <el-option
                      v-for="item in typeList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="$route.query.chapterId">
                <el-form-item label="考点" prop="name">
                  <el-select
                    multiple
                    collapse-tags
                    filterable
                    clearable
                    v-model="addForm.knowledgeIdList"
                    placeholder="考点"
                  >
                    <el-option
                      v-for="item in knowledgeList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :span="24">
              <el-col :span="12">
                <el-form-item label="难度系数" prop="hard">
                  <el-rate v-model="addForm.hard"></el-rate>
                </el-form-item>
              </el-col>
              <el-col
                v-if="(!this.$route.query.id&&this.$route.query.upPid=='0')||(!this.$route.query.id&&!this.$route.query.upPid)"
                :span="12"
              >
                <el-form-item label="是否上架" prop="state">
                  <el-radio-group v-model="addForm.state">
                    <el-radio :label="1">上架</el-radio>
                    <el-radio :label="-1">下架</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :span="24">
              <el-col :span="8" v-if="$route.query.chapterId||$route.query.examId||$route.query.id">
                <el-form-item label="排序" prop="sort">
                  <el-input type="number" v-model="addForm.sort"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :span="24">
              <el-col :span="8">
                <el-form-item label="页码" prop="page">
                  <el-input type="number" v-model="addForm.page"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :span="24">
              <el-col :span="24">
                <el-form-item label="试题题干" prop="title">
                  <div style="background: #FFF" v-if="showUe">
                    <UE id="bs" name="1" :value="titleUe" ref="myQuillEditorTitle"></UE>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :span="24">
              <el-col :span="24" v-if="showOptions&&mode!='判断'">
                <el-form-item label="试题选项">
                  <div class="th-display">
                    <el-table
                      @selection-change="selectionChange"
                      :data="tableData"
                      border
                      style="width: 100%"
                    >
                      <!-- <el-table-column type="selection" width="40"></el-table-column> -->
                      <el-table-column prop="name">
                        <template slot-scope="scope">
                          <div style="display:flex; align-items: center">
                            <div style="margin-right:10px;">{{tableData[scope.$index].options}}:</div>
                            <!-- <el-input v-model="tableData[scope.$index].name"></el-input> -->
                            <div style="height:130px;width:100%">
                              <UE1
                                :id="'id'+scope.$index"
                                :ids="scope.$index"
                                :ref="'UE1'+scope.$index"
                                :value="tableData[scope.$index].name"
                                @setName="setNameContent"
                              ></UE1>
                            </div>
                            <i
                              class="iconfont iconicon7"
                              style="margin-left:6px;color:red"
                              v-if="(scope.$index+1)==tableData.length&&tableData.length!=1"
                              @click="deleteOptions"
                              title="删除选项"
                            ></i>
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                    <div class="add-option">
                      <i class="iconfont iconicon-test" @click="addOptions" title="添加选项"></i>
                    </div>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :span="24">
              <el-col :span="24">
                <el-form-item v-if="showOptions&&mode=='单选'" label="试题答案" prop="answer">
                  <el-select clearable v-model="addForm.answer" placeholder="请选择试题答案">
                    <el-option
                      v-for="item in tableData"
                      :key="item.options"
                      :label="item.options"
                      :value="item.options"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item clearable v-if="showOptions&&mode=='多选'" label="试题答案" prop="answer">
                  <el-select
                    multiple
                    v-model="aaaa"
                    style="width:240px;"
                    @change="answerChange"
                    placeholder="请选择试题答案"
                  >
                    <el-option
                      v-for="item in tableData"
                      :key="item.options"
                      :label="item.options"
                      :value="item.options"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="showOptions&&mode=='判断'" label="试题答案" prop="answer">
                  <el-select
                    clearable
                    v-model="addForm.answer"
                    style="width:240px;"
                    placeholder="请选择试题答案"
                  >
                    <el-option
                      v-for="(item , index) in tableDataWrong"
                      :key="index "
                      :label="item.options"
                      :value="item.options"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="!showOptions" label="试题答案" prop="answer">
                  <el-input
                    type="textarea"
                    :rows="2"
                    v-model="addForm.answer"
                    placeholder="请输入试题答案"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :span="24">
              <el-col :span="24">
                <el-form-item label="试题解析" prop="analysis">
                  <div style="background: #FFF" v-if="showUe">
                    <UE id="as" :value="AnalysisUe" ref="myQuillEditorAnalysis"></UE>
                    <!-- <CKEditor ref="myQuillEditorAnalysis"></CKEditor> -->
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :span="24">
              <el-col :span="24">
                <el-form-item label="视频/音频" prop="videoPath">
                  <el-upload
                    class="crm-upload"
                    :action="fileObj.url"
                    :on-remove="handleRemove"
                    :on-change="handleChange"
                    :before-upload="beforeUpload"
                    :on-success="UploadSuccess"
                    :headers="reqData"
                    :show-file-list="false"
                  >
                    <div class="content-text">上传视频/音频</div>
                  </el-upload>
                  <video
                    style="max-height: 400px;width: auto;margin-top:20px;"
                    v-if="addForm.videoPath?addForm.videoPath.indexOf('mp4')>-1:false"
                    :src="addForm.videoPath"
                    controls
                    preload="auto"
                    oncontextmenu="return false"
                  ></video>
                  <audio
                    style="margin-top:20px;"
                    :src="addForm.videoPath"
                    controls="controls"
                    v-if="addForm.videoPath?addForm.videoPath.indexOf('mp3')>-1:false"
                  ></audio>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :span="24">
              <el-col :span="24">
                <el-form-item>
                  <div>
                    <el-button @click="goBack()">取 消</el-button>
                    <el-button type="primary" @click="addQuestion">确 定</el-button>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div style="width:30%;background: #fff;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import UE from "./UE.vue";
import UE1 from "./UE1.vue";
import CKEditor from "./CKEditor.vue";
export default {
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.routerPath = from.path;
    });
  },
  components: { UE, CKEditor, UE1 },
  data() {
    return {
      routerPath: "",
      tableDataWrong: [{ options: "对" }, { options: "错" }],
      aaaa: [],
      typeList: [], //试题类型
      fileObj: {
        url: process.env.BASE_URL + "/system/uploadFile"
      },
      tableData: [
        { name: "", options: "A" },
        { name: "", options: "B" },
        { name: "", options: "C" },
        { name: "", options: "D" }
      ],

      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children"
      },
      formLabelWidth: "80px",
      addForm: {},
      addFormRules: {
        sort: [
          {
            pattern: /^[1-9]\d*$/,
            message: "排序格式不正确"
          }
        ],
        page: [
          {
            pattern: /^[1-9]\d*$/,
            message: "页码格式不正确"
          }
        ],
        courseId: [
          {
            required: true,
            message: "请输入所属科目",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "所属科目格式不正确"
          }
        ],
        questionTypeId: [
          {
            required: true,
            message: "请输入试题题型",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "试题题型格式不正确"
          }
        ],
        state: [
          {
            required: true,
            message: "请选择是否上架",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "格式不正确"
          }
        ],
        hard: [
          {
            required: true,
            message: "请输入难度系数 1-5",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "难度系数 1-5格式不正确"
          }
        ],
        title: [
          {
            required: true,
            message: "请输入标题题干",
            trigger: "blur"
          },
          {
            min: 1,
            max: 4000,
            message: "标题题干长度在1到4000个字"
          }
        ],
        answer: [
          {
            required: true,
            message: "请输入试题答案",
            trigger: "blur"
          }
          // {
          //   min: 1,
          //   max: 255,
          //   message: "试题答案长度在1到255个字"
          // }
        ],
        analysis: [
          {
            required: true,
            message: "请输入试题解析",
            trigger: "blur"
          },
          {
            min: 1,
            max: 4000,
            message: "试题解析长度在1到4000个字"
          }
        ],
        videoPath: []
      },
      checkAddArray: [],
      knowledgeList: [],
      showOptions: false, //试题选项
      showUe: true, //试题选项
      subjectTreeList: [], //科目，
      bigTittle: "",
      AnalysisUe: "",
      titleUe: "",
      mode: "" //单选多选
    };
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    }
  },
  created() {
    if (this.$route.query.id) {
      this.getTitleById(this.$route.query.id);
    }
    if (this.$route.query.upPid && this.$route.query.upPid.length > 2) {
      this.getTitleById(this.$route.query.upPid);
    }
    if (this.$route.query.upId) {
      this.getInfoById(this.$route.query.upId);
    }
  },
  mounted() {
    this.getSubjectTreeList();
    if (this.$route.query.chapterId) {
      this.chapterKnowledgeList();
    }
    if (this.$route.query.id) {
      this.addForm = {
        questionTypeId: "",
        hard: 0,
        title: "",
        answer: "",
        sort: null,
        analysis: "",
        page: "",
        optionList: [],
        videoPath: "",
        pid: this.$route.query.id
      };
    } else {
      this.addForm = {
        courseId: "",
        questionTypeId: "",
        state: 1,
        hard: 0,
        title: "",
        page: "",
        sort: null,
        answer: "",
        analysis: "",
        optionList: [],
        knowledgeIdList: [],
        videoPath: ""
      };
    }
  },
  methods: {
    setNameContent(val) {
      console.log(val.content);
      if (val.index >= 0) {
        this.tableData[val.index].name = val.content;
      }
    },
    chapterKnowledgeList(id) {
      this.api.chapter
        .chapterKnowledgeList({
          chapterId: this.$route.query.chapterId
        })
        .then(result => {
          this.knowledgeLoading = false;
          if (result.success) {
            this.knowledgeList = result.data;
            if (this.$route.query.knowledgeId) {
              this.addForm.knowledgeIdList[0] = this.$route.query.knowledgeId;
            }
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 获取试题信息
    getInfoById(id) {
      this.showUe = false;
      let obj = {
        id: id
      };
      if (this.$route.query.chapterId) {
        obj.chapterId = this.$route.query.chapterId;
      }
      this.api.question.getInfoById(obj).then(result => {
        if (result.success) {
          this.addForm = {
            courseId: result.data.courseId,
            questionTypeId: result.data.questionTypeId,
            state: result.data.state,
            hard: result.data.hard,
            title: result.data.title,
            sort: result.data.sort,
            page: result.data.page,
            answer: result.data.answer,
            analysis: result.data.analysis,
            optionList: result.data.optionList,
            videoPath: result.data.videoPath,
            id: result.data.id,
            knowledgeIdList: result.data.knowledgeIdStrList,
            pid: this.$route.query.upPid
          };
          // if (this.$route.query.upPid.length > 2) {
          //   this.addForm = {
          //     questionTypeId: result.data.questionTypeId,
          //     hard: result.data.hard,
          //     title: result.data.title,
          //     sort: result.data.sort,
          //     answer: result.data.answer,
          //     analysis: result.data.analysis,
          //     optionList: result.data.optionList,
          //     videoPath: result.data.videoPath,
          //     id: result.data.id,
          //     pid: this.$route.query.upPid
          //   };
          // }
          (this.AnalysisUe = result.data.analysis),
            (this.titleUe = result.data.title),
            (this.tableData = result.data.optionList || []);
          if (result.data.optionList.length > 0) {
            this.showOptions = true;
            if (result.data.questionTypeName.indexOf("单选") > -1) {
              this.mode = "单选";
            } else {
              this.mode = "多选";
              this.aaaa = result.data.answer.split(",");
            }
          } else if (result.data.questionTypeName.indexOf("判断") > -1) {
            this.showOptions = true;
            this.mode = "判断";
          }
          this.ueTtext = result.data.title;
          this.showUe = true;
        }
      });
    },
    getTitleById(id) {
      this.api.question.getTitleById({ id: id }).then(result => {
        if (result.success) {
          this.bigTittle = result.data;
        }
      });
    },
    // 删除选项
    deleteOptions() {
      this.tableData.splice(this.tableData.length - 1, 1);
    },
    // 添加选项
    addOptions() {
      this.tableData.push({
        name: "",
        options: String.fromCharCode(64 + parseInt(this.tableData.length + 1))
      });
      console.log(this.tableData);
    },
    selectionChange(val) {
      console.log(val);
      this.addForm.optionList = val;
    },
    UploadSuccess(res, file, fileList, val) {
      this.addForm.videoPath = res.data;
    },
    handleRemove(file, fileList) {
      this.addForm.videoPath = "";
    },
    handleChange(file, fileList) {},
    beforeUpload(file) {
      const isVideo = file.type.indexOf("video") > -1;
      const isAudio = file.type.indexOf("audio") > -1;
      console.log(isAudio);
      console.log(isVideo);
      if (!isVideo && !isAudio) {
        this.$message.error("上传文件必须是音频哦!");
      }
      return isVideo || isAudio;
    },
    // 试题选项
    checkAdd(val) {
      console.log(val);
      // var fruits = ["Banana", "Orange", "Apple", "Mango"];
      // // fruits.push("Kiwi");
      // let aaa = true;
      // if (this.checkAddArray.length == 0) {
      //   this.checkAddArray.push(val);
      // } else {
      //   this.checkAddArray.forEach((item, index) => {
      //     // console.log("item", item);
      //     if (item == val) {
      //       this.checkAddArray.splice(index, 1);
      //       aaa = false;
      //     } else {
      //     }
      //   });
      //   if (aaa) {
      //     this.checkAddArray.push(val);
      //   }
      // }

      // console.log(this.checkAddArray);
    },
    // 具体课程change事件
    subjectChange(val) {
      console.log(val);
      if (val.length > 0) {
        this.addForm.courseId = val[val.length - 1];
      } else {
        this.addForm.courseId = "";
      }
    },
    answerChange(val) {
      console.log(val);
      this.addForm.answer = "";
      val.forEach(item => {
        this.addForm.answer = this.addForm.answer
          ? this.addForm.answer + "," + item
          : item;
      });
      console.log("this.addForm.answer", this.addForm.answer);
    },
    typeChange(val) {
      for (let item of this.typeList) {
        if (item.id == val) {
          if (item.mode == "判断") {
            this.showOptions = true;
            this.mode = item.mode;
          } else if (item.mode == "单选" || item.mode == "多选") {
            if (item.mode == "单选") {
              this.mode = "单选";
              this.addForm.answer = "";
            } else if (item.mode == "多选") {
              this.mode = "多选";
              this.addForm.answer = "";
            }
            this.showOptions = true;
          } else {
            this.mode = item.mode;
            this.addForm.answer = "";
            this.showOptions = false;
          }
        }
      }
    },
    //   获取下拉
    getSubjectTreeList() {
      // 获取课程
      this.api
        .getSubjectCourseTreeList()
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    delete itemss.children;
                  }
                } else {
                  // delete items.children;
                }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
      // 获取试题类型
      if (this.$route.query.examId || this.$route.query.examIds) {
        this.api.question
          .questionTypeByExam({
            examId: this.$route.query.examId || this.$route.query.examIds
          })
          .then(result => {
            this.typeList = result.data;
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.api.question
          .questionTypeNormalList()
          .then(result => {
            this.typeList = result.data;
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    //   返回上一页
    goBack() {
      console.log(22222, this.routerPath);
      if (this.$route.query.chapterId || this.$route.query.chapterIds) {
        this.$router.push({
          path: "/chapterView",
          query: {
            chapterId:
              this.$route.query.chapterId || this.$route.query.chapterIds,
            knowledgeId: this.$route.query.knowledgeId || ""
          }
        });
      } else if (this.$route.query.examId || this.$route.query.examIds) {
        this.$router.push({
          path: "/examView",
          query: {
            examId: this.$route.query.examId || this.$route.query.examIds
          }
        });
      } else if (this.routerPath) {
        this.$router.push({
          path: this.routerPath,
          query: {
            id: this.$route.query.idsss
          }
        });
      }
    },
    // 添加问题
    addQuestion() {
      let abc = true;
      let itemName = "";
      if (this.showOptions) {
        this.tableData.forEach((item, index) => {
          item.name = this.$refs["UE1" + index]._data.content;
          if (!item.name) {
            return (abc = false), (itemName = item.options);
          }
        });
        this.addForm.optionList = this.tableData;
      }
      if (!abc) {
        return this.$message.error(itemName + "选项不能为空");
      }
      if (
        !this.$refs.myQuillEditorTitle._data.content &&
        !this.$refs.myQuillEditorAnalysis._data.content
      ) {
        return this.$message.error("试题题干、试题解析不能为空");
      }
      let apistyle = "";
      if (this.$route.query.upId && this.$route.query.upPid.length > 2) {
        apistyle = "updateSmallQuestion";
      } else if (this.$route.query.upId && this.$route.query.upPid.length < 2) {
        apistyle = "updateNormalQuestion";
      } else if (this.$route.query.id) {
        apistyle = "addSmallQuestion";
      } else {
        apistyle = "addNormalQuestion";
      }
      if (this.$route.query.examId) {
        this.addForm.examId = this.$route.query.examId || "";
      }
      if (this.$route.query.chapterId) {
        this.addForm.chapterId = this.$route.query.chapterId || "";
      }
      this.addForm.title = this.$refs.myQuillEditorTitle._data.content;
      // this.addForm.title = this.addForm.title
      //   .replace(this.addForm.title ? /&(?!#?\w+;)/g : /&/g, "&amp;")
      //   .replace(/&lt;/g, "<")
      //   .replace(/&gt;/g, ">")
      //   .replace(/&quot;/g, '"')
      //   .replace(/&#39;/g, "'");
      this.addForm.analysis = this.$refs.myQuillEditorAnalysis._data.content;
      // this.addForm.analysis = this.addForm.analysis
      //   .replace(this.addForm.analysis ? /&(?!#?\w+;)/g : /&/g, "&amp;")
      //   .replace(/&lt;/g, "<")
      //   .replace(/&gt;/g, ">")
      //   .replace(/&quot;/g, '"')
      //   .replace(/&#39;/g, "'");
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.api.question[apistyle](this.addForm)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.addFormVisible = false;
                this.goBack();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="less" rel="stylesheet/less">
#addQuestion {
  width: 100%;
  height: 100%;
  background: #fff;
  padding-top: 10px;
  .add-title {
    height: 60px;
    background: inherit;
    background-color: rgba(255, 255, 255, 1);
    box-sizing: border-box;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
    line-height: 60px;
    font-size: 18px;
    color: #333;
    margin-bottom: 20px;

    span {
      color: rgb(162, 170, 188);
      font-size: 18px;
      margin-left: 20px;
    }
  }
  .th-display {
    display: flex;
    flex-direction: row;
    .add-option {
      width: 6%;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      background: #fff;
      i {
        font-size: 20px;
        margin-top: 10px;
      }
      cursor: pointer;
      color: #0085e8;
    }
    th {
      display: none;
    }
  }
  .content-text {
    width: 100px;
    height: 30px;
    line-height: 30px;
    border-radius: 4px;
    border: 1px solid rgb(77, 148, 255);
    color: rgb(77, 148, 255);
    font-size: 12px;
    text-align: center;
    background: #fff;
  }
  .add-list {
    display: flex;
    flex-direction: row;
    .list-item {
      margin-right: 30px;
      color: #4d94ff;
      font-size: 14px;
      font-weight: bold;
      border-bottom: rgb(246, 249, 250) solid 2px;

      &:hover {
        border-bottom: #4d94ff solid 2px;
        box-sizing: border-box;
      }
      i {
        color: #4d94ff;
        font-size: 14px;
        cursor: pointer;
      }
    }
    .list-item:last-child {
      &:hover {
        border-bottom: rgb(246, 249, 250) solid 2px;
        box-sizing: border-box;
      }
      cursor: pointer;
    }
  }
  .el-rate {
    line-height: 2 !important;
  }
  .big-tittle {
    p {
      margin: 0px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/question/addQuestion.vue